import { Action } from '@ngrx/store';
import { Order } from '../../../models/orderbook.model';
import { StateChange } from '../../../models/StateChange';
import { StateChangeMessage } from '../../../models/StateChangeMessage';
import { SaveCurrencyPair } from '../../../admin/SaveCurrencyPair';

export enum MatchBoardActionTypes {
  InitState = '[INIT] Init state action',
  // partial match, trades, swaps, allOrders (super user)
  OrdersMatched = '[ORDERS_MATCHED] Orders matched',
  OrderMatched = '[ORDER_MATCHED] Order matched',
  NewOrders = '[NEW ORDERS] New orders created',
  ModifyOrder = '[MODIFY ORDER]', // partial match
  UpdateOrders = '[UPDATE ORDER]', //
  RemoveOrders = '[REMOVE ORDERS]',
  StateChanged = '[STATE CHANGED]', // common
  UpdateSpotPrices = '[UPDATE SPOT PRICES] Update spot prices',
  SelectOnBehalfUser = '[SELECT_ON_BEHALF_USER]',
  ChangeCardCurrencyPair = '[CHANGE_CARD_CURRENCY_PAIR]',
  SelectTab = '[SELECT_TAB]',
  PositionsUpdate = '[POSITIONS_UPDATE] Update ABOS positions',
  UpdateGraphData = '[UPDATE_GRAPH_DATA] Update graph data',
  CurrencyPairsUpdate = '[UPDATE_CURRENCY_PAIRS] Update currency pairs'
  // AddOrder = '[ADD_ORDER] Add order action',
  // RemoveOrder = '[INIT] Remove order action',
  // AddTrades = '[ADD_TRADES] Add trade action',
  // AddSwap = ''
}

export class InitState implements Action {
  readonly type = MatchBoardActionTypes.InitState;

  constructor(public state: any) {
  }
}

export class OrdersMatched implements Action {
  readonly type = MatchBoardActionTypes.OrdersMatched;

  constructor(public payload: StateChangeMessage) {
  }
}

// export class OrderMatched implements Action {
//   readonly type = MatchBoardActionTypes.OrderMatched;
//
//   constructor(public payload: OrderMatchedState) {
//   }
// }

export class NewOrders implements Action {
  readonly type = MatchBoardActionTypes.NewOrders;

  constructor(public orders: Array<Order>) {
  }
}

export class StateChanged implements Action {
  readonly type = MatchBoardActionTypes.StateChanged;

  constructor(public payload: StateChange) {
  }
}

export class UpdateSpotPrices implements Action {
  readonly type = MatchBoardActionTypes.UpdateSpotPrices;

  constructor(public payload: any) {
  }
}

export class RemoveOrders implements Action {
  readonly type = MatchBoardActionTypes.RemoveOrders;

  constructor(public orderIds: Array<number>) {
  }
}


export class SelectOnBehalfUser implements Action {
  readonly type = MatchBoardActionTypes.SelectOnBehalfUser;

  constructor(public selectOnBehalfUser: any) {
  }
}

export class ChangeCardCurrencyPair implements Action {
  readonly type = MatchBoardActionTypes.ChangeCardCurrencyPair;

  constructor(public tabName: string, public id: number, public sixLetterCode: string) {
  }
}

export class SelectTab implements Action {
  readonly type = MatchBoardActionTypes.SelectTab;

  constructor(public tabName: string, public isActive: boolean) {
  }
}

export class PositionsUpdate implements Action {
  readonly type = MatchBoardActionTypes.PositionsUpdate;

  constructor(public payload: Array<any>) {
  }
}

export class UpdateGraphData implements Action {
  readonly type = MatchBoardActionTypes.UpdateGraphData;

  constructor(public payload: any) {
  }
}

export class CurrencyPairsUpdate implements Action {
  readonly type = MatchBoardActionTypes.CurrencyPairsUpdate;

  constructor(public payload: SaveCurrencyPair) {
  }
}

export type MatchBoardActions =
  InitState |
  OrdersMatched |
  NewOrders |
  StateChanged |
  UpdateSpotPrices |
  RemoveOrders |
  SelectOnBehalfUser |
  ChangeCardCurrencyPair |
  SelectTab |
  PositionsUpdate |
  UpdateGraphData |
  CurrencyPairsUpdate;
